import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import dict from '../dictionary';
import ReducedData from '../reducedData.json';

import {
  labelStyle,
  tooltip,
  stroke,
  markers,
  legend,
  responsiveFun,
  lineXaxis,
  getColours,
} from './options';
import trans from '../translations.json';
import { DownloadButton } from './options';
import StackedTable from './deathsTotal-table';
import { ButtonGroup } from './buttonGroup/buttonGroup';
const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colourPalette = getColours(['death']);

class DeathsTotal extends Component {
  state = {
    ready: false,
    dates: [],
    series: [],
    options: {},
    selectedViewMode: viewModes.graph,
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.setData();
    }
  }

  setData = () => {
    var covidData = ReducedData.covidData;
    const cData = [...covidData];
    const chartData = cData
      .filter((item) => item[dict.deaths] > 0)
      .map((item) => {
        return [item[dict.reportedDate], item[dict.deaths]];
      });

    this.setState({
      series: [
        {
          name: trans.deathsTotal.deaths[this.props.lang],
          data: chartData,
          type: 'area',
        },
      ],

      options: {
        legend: legend,
        tooltip: tooltip,
        stroke: stroke,
        responsive: responsiveFun().map((item) => {
          item.options.xaxis = { ...lineXaxis(true) };
          item.options.yaxis.title.text =
            trans.deathsTotal.yaxis[this.props.lang];
          return item;
        }),
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          zoom: { enabled: true },
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        yaxis: {
          title: {
            text: trans.deathsTotal.yaxis[this.props.lang],
          },
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            hideOverlappingLabels: true,
            format: 'MMMM dd',
            rotateAlways: true,
            rotate: -45,
            offsetY: 5,
            style: { ...labelStyle },
          },
        },
        colors: colourPalette,
        markers: markers,
        fill: {
          opacity: [0.5, 1],
        },
      },
      ready: true,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              type="line"
              height="400px"
              aria-hidden="true"
            />
          );
        case viewModes.table:
          return <StackedTable lang={this.props.lang} />;
        default:
      }
    };

    return (
      <div id="">
        <p>{trans.deathsTotal.desc[this.props.lang]}</p>
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />

            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default DeathsTotal;
